import WeekHelper from '../../../../functions/WeekHelper';

export const getCoveringRateWithoutInitialAssignment = (coveringRate, initialAssignment) => {
    if (!initialAssignment) {
        return coveringRate;
    }
    let coveringRateWithoutInitialAssignment = {};
    Object.keys(coveringRate).forEach((week) => {
        let newPct;
        if (week >= initialAssignment.begWek && week <= initialAssignment.endWek) {
            newPct = coveringRate[week] - initialAssignment.pct;
        } else {
            newPct = coveringRate[week];
        }
        coveringRateWithoutInitialAssignment[week] = newPct;
    });
    return coveringRateWithoutInitialAssignment;
};

export const calculateMaxPctAvailable = (coveringRate, begWeek, endWeek) => {
    let maxPctAvailable = 100;
    WeekHelper.GetWeeksBetween(begWeek, endWeek).forEach((week) => {
        let availablePctCurrentWeek = 100 - (coveringRate[week] || 0);
        maxPctAvailable = Math.min(maxPctAvailable, availablePctCurrentWeek);
    });

    return maxPctAvailable;
};

const addDays = (date, nDays) => {
    var newDate = new Date(date.valueOf());
    newDate.setDate(newDate.getDate() + nDays);
    return newDate;
};

export const calculateDateBoundaries = (coveringRate, thisWeek, begWeek, endWeek) => {
    let minSelectableWeek;
    let maxSelectableWeek;

    // For rerender when not all states have been set.
    // e.g. For rerender when begWeek is moved past endWeek, then this will run before endWeek is also moved.
    if (begWeek === undefined || endWeek === undefined || thisWeek === undefined || endWeek < begWeek) {
        return [null, null];
    }

    const coveringRateKeys = Object.keys(coveringRate);
    const lastCoveringRateWeek = coveringRateKeys[coveringRateKeys.length - 1];

    if (begWeek < thisWeek) {
        minSelectableWeek = WeekHelper.AddWeeks(thisWeek, -1);
    } else if (begWeek === thisWeek) {
        minSelectableWeek = thisWeek;
    } else {
        for (const week of WeekHelper.GetWeeksBetween(thisWeek, begWeek).reverse()) {
            if (coveringRate[week] === 100) {
                minSelectableWeek = WeekHelper.AddWeeks(week, 1);
                break;
            }
        }
        if (!minSelectableWeek) {
            minSelectableWeek = WeekHelper.AddWeeks(thisWeek);
        }
    }

    if (endWeek < thisWeek) {
        minSelectableWeek = null;
        maxSelectableWeek = null;
    } else {
        if (coveringRateKeys.length < 1) {
            minSelectableWeek = null;
            maxSelectableWeek = null;
        } else {
            for (const week of WeekHelper.GetWeeksBetween(endWeek, lastCoveringRateWeek)) {
                if (coveringRate[week] === 100) {
                    maxSelectableWeek = WeekHelper.AddWeeks(week, -1);
                    break;
                }
            }
        }
    }

    let minSelectableDate = WeekHelper.GetMondayDateOfWeek(minSelectableWeek || thisWeek);
    let maxSelectableDate;
    if (maxSelectableWeek) {
        maxSelectableDate = WeekHelper.GetMondayDateOfWeek(maxSelectableWeek);
        maxSelectableDate = addDays(maxSelectableDate, 6);
    } else {
        maxSelectableDate = null;
    }

    return [minSelectableDate, maxSelectableDate];
};

export const assignmentsEquals = (a, b) => {
    return a.begWek === b.begWek && a.endWek === b.endWek && a.bltID === b.bltID && a.pct === b.pct && a.dsc === b.dsc;
};
